import type { FC } from 'react';
import { OopsConceptsWrapper } from './OopsConcepts.styled';

interface OopsConceptsProps {}

const OopsConcepts: FC<OopsConceptsProps> = () => (
 <OopsConceptsWrapper>
   <header className="entry-header ">
      <h1 className="entry-title" itemProp="headline">OOPS Concepts</h1>			
   </header>
   <div className="entry-content clear" itemProp="text">
      <p className="text-align-justify">As the name suggests, Object-oriented programming is based on the concept of objects. It aims to implement real-world entities like Inheritance, Abstraction, Encapsulation, Data Hiding, and Polymorphism.&nbsp;</p>
      <p className="text-align-justify">In this section of our training, we will be covering the following topics :</p>
      <ul className="text-align-justify">
         <li><a href="/4-pillars-of-oops">4 Pillars of OOPS</a></li>
         <li><a href="/classes-objects">Classes &amp; Objects</a></li>
         <li><a href="/constructors-destructors">Constructor &amp; Destructor</a></li>
         <li><a href="/static-this-super-final-keyword">Keywords like static, this, super, final</a></li>
         <li><a href="/initializer-block">Initializer block</a></li>
         <li><a href="/access-modifier">Access Modifier</a></li>
      </ul>
   </div>
</OopsConceptsWrapper>
);

export default OopsConcepts;
